const parser = (name: string): string | null => {
  const tag = document.querySelector(`meta[name="${name}"]`);
  return tag ? tag.getAttribute('content') : null;
};

export { parser };
